<template>
    <div>
        <v-data-table
            loading-text="Loading..."
            :disable-filtering="true"
            :disable-sort="true"
            :loading="logs.loading"
            :headers="logs.headers"
            :items="logs.items"
            :options.sync="logs.options"
            :items-per-page="logs.options.itemsPerPage"
            :server-items-length="logs.totals"
            :item-class="rowClass"
            :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                disableItemsPerPage: true,
                itemsPerPageOptions: [logs.options.itemsPerPage]
            }">
            <template v-slot:item.user_name="{ item, value }">
                <div class="font-weight-bold">{{ value }}</div>
                <div>{{ item.user_email }}</div>
            </template>

            <template v-slot:item.action="{ item }">
                {{ item.type }} / {{ item.action }}
            </template>

            <template v-slot:item.data="{ item, value }">
                <template v-if="item.type === 'user' && ['registration', 'email_verification', 'login'].indexOf(item.action) > -1">
                    <div class="text-caption">{{ value.ip }}</div>
                    <div class="text-caption">
                        {{ value.country }} &bull; {{ value.state_name }} &bull; {{ value.city }}
                    </div>
                </template>
                <template v-else>
                    <pre class="text-caption">{{ value }}</pre>
                </template>
            </template>

            <template v-slot:item.event_date="{ item }">
                <span class="text--secondary text-caption">{{ item.event_date }} {{ item.event_time }}</span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logs: {
                options: {
                    page: 1,
                    itemsPerPage: 20
                },
                loading: false,
                totals: 0,
                headers: [
                    {
                        text: 'User',
                        value: 'user_name',
                    },
                    {
                        text: 'Event',
                        value: 'action',
                    },
                    {
                        text: 'Data',
                        value: 'data',
                    },
                    {
                        text: 'Date & Time',
                        value: 'event_date',
                        align: 'end'
                    },
                ],
                items: []
            }
        }
    },

    watch: {
        'logs.options.page'(new_val, old_val) {
            this.pullLogs();
        },
    },

    mounted() {
        this.pullLogs();
    },

    methods: {
        rowClass(item) {
            return '';
        },

        pullLogs() {
            (new DBActivityLogs(this))
                .addParam('page', this.logs.options.page)
                .before(() => {
                    this.logs.loading = true;
                })
                .after(response => {
                    this.logs.loading = false;
                    this.logs.totals = response.data.data.total;
                    this.logs.items = response.data.data.data;
                    this.logs.options.page = response.data.data.current_page;
                    this.logs.options.itemsPerPage = response.data.data.per_page;
                })
                .error(error => {
                    this.logs.loading = false;
                })
                .get();
        }
    }
}
</script>
